import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useProperty } from '../../hooks/useProperty';
import { FORMS } from '../../schemas/stepMap';
import FormBuilder from '../../components/formBuilder';
import { Helmet } from 'react-helmet';
import PropertyPageHeader from '../../components/PropertyPageHeader';

export default function FlipWorksheet() {
  const { propertyData } = useProperty();
  const { propertyId } = useParams();
  const navigate = useNavigate();

  if (propertyData?.projectType !== 'flip') {
    navigate('../purchase-worksheet');
  }

  const purchaseWorksheetSchema = FORMS.flipWorksheet.schema;

  return (
    <>
      <Helmet>
        <title>PropertyCast.io - Flip Worksheet</title>
      </Helmet>
      <section>
        <PropertyPageHeader
          title={purchaseWorksheetSchema.inputs.title}
          description={purchaseWorksheetSchema.inputs.description}
        />

        <FormBuilder
          formSchema={purchaseWorksheetSchema}
          formType={FORMS.purchaseWorksheet.formType}
          data={propertyData}
          beforeAfterData={{}}
          docId={propertyId}
        />
        <div></div>
      </section>
    </>
  );
}
